import { PHOTO_LOADER } from "../constants"

class LoaderElement {
  constructor(element) {
    this.element = element
  }

  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_LOADER)
    return element ? new LoaderElement(element) : null
  }

  toggleVisibility(shouldBeVisible) {
    if (!this.element) return
    this.element.classList.toggle("is-hidden", !shouldBeVisible)
  }
}

export default LoaderElement
